import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Books from './pages/Books';
import Videos from './pages/Videos';
import Cities from './pages/Cities';
import Users from './pages/Users';
import Broadcast from './pages/Broadcast';
import Admins from './pages/Admins';
import Settings from './pages/Settings';
import CodeGen from './pages/CodeGen';
import Logs from './pages/Logs';
// ---- NEW PAGES ----
import MenuControl from './pages/MenuControl';
import JoinTeam from './pages/JoinTeam';
import ProgramInfo from './pages/ProgramInfo';
import Donate from './pages/Donate';
import { ContactUs } from './pages/ContactUs';
import { Masail } from './pages/Masail';
import { SocialMedia } from './pages/SocialMedia';
import { MediaSend } from './pages/MediaSend';


function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <span className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/"             element={<Dashboard />} />
                <Route path="/books"        element={<Books />} />
                <Route path="/videos"       element={<Videos />} />
                <Route path="/cities"       element={<Cities />} />
                <Route path="/users"        element={<Users />} />
                <Route path="/broadcast"    element={<Broadcast />} />
                <Route path="/admins"       element={<Admins />} />
                <Route path="/settings"     element={<Settings />} />
                <Route path="/codegen"      element={<CodeGen />} />
                <Route path="/logs"         element={<Logs />} />
                {/* ---- NEW ROUTES ---- */}
                <Route path="/menu-control" element={<MenuControl />} />
                <Route path="/join-team"    element={<JoinTeam />} />
                <Route path="/program"      element={<ProgramInfo />} />
                <Route path="/donate"       element={<Donate />} />
                <Route path="/contact"      element={<ContactUs />} />
                <Route path="/masail"       element={<Masail />} />
                <Route path="/social"       element={<SocialMedia />} />
                <Route path="/media"        element={<MediaSend />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}